import React from 'react'
import InLineWidget from '../BookingWidget/InLineWidget'

const InLine = () => {
  return <InLineWidget />
}

export default InLine
